import { RecollectionIntervalMode } from '@/modules/decisioning-criteria/utils/recollectionIntervalCriterion';

export const RECOLLECTION_INTERVAL_DESCRIPTION =
    'Choose how the re-collection date for this document is set.';

export const RECOLLECTION_INTERVAL_MODE_LABELS: Record<RecollectionIntervalMode, string> = {
    RECURRING_CADENCE: 'Recurring cadence',
    CUSTOM_DATE_PER_SUBMISSION: 'Custom date per submission',
};

export const RECOLLECTION_INTERVAL_MODE_DESCRIPTIONS: Record<RecollectionIntervalMode, string> = {
    RECURRING_CADENCE: 'Every submission expires a fixed period after it is submitted.' +
        ' The date is set automatically and reviewers are not asked for one.',
    CUSTOM_DATE_PER_SUBMISSION: 'The reviewer sets the re-collection date in the Document Verification' +
        ' action, for every submission. No date is calculated automatically.',
};

export const RECOLLECTION_INTERVAL_NET_NEW_NOTE =
    'Changes apply to net-new submissions only. Entities that already submitted keep their current' +
    ' re-collection date.';
